module.exports = "<!--ESSA É A VARIAVEL QUE RETORNA A QUANTIDADE EM DIAS QUE FALTA PARA EXPIRAR O PLANO TRIAL.-->\n<!--PRA CHAMAR ESSE COMPONENTE VOCÊ DEVE USAR A TAG <trial-countdown> NO ARQUIVO top-navbar.blade.php-->\n<div v-if=\"show\">\n    <div class=\"row\">\n        <div class=\"col-xs-12 text-center\" style=\"height: 40px;line-height: 40px;\" :class=\"bgColor\">\n            {{{ message }}}\n        </div>\n    </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/javascript/templates/system-alerts.html
// module id = ./resources/assets/javascript/templates/system-alerts.html
// module chunks = 53